import { CalendarClock, X } from "lucide-react";

const formatWhen = (iso) =>
  iso
    ? new Date(iso).toLocaleString("es-ES", { dateStyle: "full", timeStyle: "short" })
    : "—";

/**
 * Lists pending Resend-scheduled broadcasts with a cancel action.
 * Returns nothing when there are no scheduled items.
 */
const ScheduledList = ({ scheduled = [], loading, onCancel }) => {
  if (!scheduled.length) return null;
  return (
    <div className="bg-white rounded-3xl border border-sand/50 mt-10 overflow-hidden" data-testid="scheduled-list">
      <div className="p-7 border-b border-sand/40 flex items-center gap-3">
        <CalendarClock size={18} className="text-terracotta" />
        <h2 className="font-serif text-2xl text-charcoal">Envíos programados</h2>
        <span className="text-xs text-charcoal/55">({scheduled.length})</span>
      </div>
      <ul className="divide-y divide-sand/40">
        {scheduled.map((b) => (
          <li
            key={b.id}
            className="p-5 flex items-center justify-between gap-4"
            data-testid={`scheduled-item-${b.id}`}
          >
            <div className="min-w-0 flex-1">
              <p className="font-serif text-lg text-charcoal truncate">{b.subject}</p>
              <p className="text-[12.5px] text-charcoal/60 mt-1">
                <CalendarClock size={12} className="inline-block mr-1.5 -mt-0.5" />
                {formatWhen(b.scheduled_at)} · {b.recipients_count} destinatarias
              </p>
            </div>
            <button
              onClick={() => onCancel(b.id, b.subject)}
              disabled={loading}
              data-testid={`cancel-scheduled-${b.id}`}
              className="inline-flex items-center gap-1.5 text-xs text-terracotta border border-terracotta/40 rounded-full px-3.5 py-2 hover:bg-terracotta hover:text-ivory transition-colors disabled:opacity-50 shrink-0"
            >
              <X size={13} /> Cancelar
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ScheduledList;
